var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        visible: _vm.showLoading,
        size: "sm",
        "modal-class": "loading-modal",
        "hide-header-close": "",
        "hide-header": "",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        centered: "",
        "no-fade": ""
      }
    },
    [
      _c(
        "b-container",
        { staticClass: "text-center", attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  {
                    staticClass: "loader",
                    attrs: { "data-test-ref": "attached-app-loader" }
                  },
                  [_c("loading")],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22ee65ab", { render: render, staticRenderFns: staticRenderFns })
  }
}